import React, { useState, useEffect } from "react";
import SignatureAnimation from "./SignatureAnimation";
import "./SplashScreen.css";

function SplashScreen({ onComplete }) {
  const [animationCompleted, setAnimationCompleted] = useState(false);

  useEffect(() => {
    // Total animation time from CSS: 5s for all animations + 0.23s for the final animation
    const totalAnimationTime = 5000 + 230 + 300; // Adding 300ms buffer

    // Start fade out after animation completes
    const timer = setTimeout(() => {
      setAnimationCompleted(true);
    }, totalAnimationTime);

    // Cleanup timer
    return () => clearTimeout(timer);
  }, []);

  // After fade out animation completes, call the onComplete callback
  useEffect(() => {
    if (animationCompleted) {
      // Previously, a long delay (5000ms) was here for the splash screen's own fade-out.
      // Call onComplete much sooner to allow home page animations to start concurrently
      // with the splash screen fading out.
      const shortDelayTimer = setTimeout(() => {
        onComplete && onComplete();
      }, 2200); // Reduced delay to 100ms (from 5000ms)

      return () => clearTimeout(shortDelayTimer);
    }
  }, [animationCompleted, onComplete]);

  return (
    <div className={`splash-screen ${animationCompleted ? "fade-out" : ""}`}>
      <SignatureAnimation className="splash-signature" />
    </div>
  );
}

export default SplashScreen;
